module.exports = __webpack_public_path__ + "static/favicon-bae6c86905a689b2e4d4469245210575.png";